import { styled } from "@mui/material/styles";

import { HbmlElementNode } from "@holibob-packages/hbml";

import { HbmlRendererNodes, Typography } from "../../components";
import { HbmlElements } from "../../components/HbmlComponents";
import { useNextTranslation } from "../../hooks";
import { ProductContentEntryV2 } from "../types";
import { ProductContentHbmlRenderer } from "./ProductContentHbmlRenderer";
import { normalizeProductContentToBulletedList } from "./utils/normalizeProductContentToBulletedList";

type ProductHighlightsProps = { content: ProductContentEntryV2[] };

const BulletListOverride = function ({ content }: { content: HbmlElementNode }) {
    return (
        <Typography variant="ul" color="subtle">
            <HbmlRendererNodes content={content.children} />
        </Typography>
    );
};

export const ProductHighlights = ({ content }: ProductHighlightsProps) => {
    const [t] = useNextTranslation("product");
    const finalContent = normalizeProductContentToBulletedList(content);

    return (
        <div>
            <ProductHighlightsTitle variant="title" fontWeight="bold">
                {t("highlights.title")}
            </ProductHighlightsTitle>
            <ProductContentHbmlRenderer
                content={finalContent}
                componentOverrides={{
                    [HbmlElements.BULLETED_LIST]: BulletListOverride,
                }}
            />
        </div>
    );
};

const ProductHighlightsTitle = styled(Typography)(({ theme }) => ({
    fontWeight: theme.typography.fontWeightMedium,
}));
